import React from "react";
import { TableHeadersType } from "../../../../../constant/tableHeadersConstants/tableHeadersType";
import Gstr3bThreePointOneTableData from "./Gstr3bThreePointOneTableData";
import Gstr3bThreePointTwoTableData from "./Gstr3bThreePointTwoTableData";
import Gstr3BFourTableData from "./Gstr3BFourTableData";
import Gstr3BFiveTableData from "./Gstr3BFiveTableData";
import Gstr3BFivePointOneTableData from "./Gstr3BFivePointOneTableData";
import Gstr3BSixPointOneTableData from "./Gstr3BSixPointOneTableData";
import Gstr3BBreakupTaxLiabilityDeclaredTableData from "./Gstr3BBreakupTaxLiabilityDeclaredTableData";
import { GstrThreeBDataType } from "../../../../../commonTypes/gstTypes";
type AppProps = {
  tableHeader: string;
  tableHeaderData: TableHeadersType[];
  data: any;
  gstrThreeBData: GstrThreeBDataType | {};
  singleHeader: string;
};
const GstrThreeBTableData = ({
  tableHeader,
  data,
  tableHeaderData,
  gstrThreeBData,
  singleHeader,
}: AppProps) => {
  const renderTableData = () => {
    switch (tableHeader) {
      case "3.1 Details of Outward supplies and inward supplies liable to reserve charge":
        return (
          <Gstr3bThreePointOneTableData
            tableHeaderData={tableHeaderData}
            gstrThreeBData={gstrThreeBData}
            singleHeader={singleHeader}
          />
        );
      case "3.1.1 Details of Supplies notified under section 9(5) of the CGST Act, 2017 and corresponding provisions in IGST/UTGST/ SGST Acts":
        return (
          <Gstr3bThreePointOneTableData
            tableHeaderData={tableHeaderData}
            gstrThreeBData={gstrThreeBData}
            type={"3.1.1"}
            singleHeader={singleHeader}
          />
        );
      case "3.2 Out of supplies made in 3.1 (a) and 3.1.1 (i), details of inter-state supplies made":
        return (
          <Gstr3bThreePointTwoTableData
            tableHeaderData={tableHeaderData}
            gstrThreeBData={gstrThreeBData}
            singleHeader={singleHeader}
          />
        );
      case "4. Eligible ITC":
        return (
          <Gstr3BFourTableData
            tableHeaderData={tableHeaderData}
            gstrThreeBData={gstrThreeBData}
            singleHeader={singleHeader}
          />
        );
      case "5. Values of exempt, nil-rated and non-GST inward supplies":
        return (
          <Gstr3BFiveTableData
            tableHeaderData={tableHeaderData}
            gstrThreeBData={gstrThreeBData}
            singleHeader={singleHeader}
          />
        );
      case "5.1 Interest and Late fee for previous tax period":
        return (
          <Gstr3BFivePointOneTableData
            tableHeaderData={tableHeaderData}
            data={data?.data}
          />
        );
      case "6.1 Payment of tax":
        return (
          <Gstr3BSixPointOneTableData
            tableHeader={tableHeader}
            tableHeaderData={tableHeaderData}
            data={data?.data}
          />
        );
      case "Breakup of tax liability declared (for interest computation)":
        return (
          <Gstr3BBreakupTaxLiabilityDeclaredTableData
            tableHeaderData={tableHeaderData}
            gstrThreeBData={gstrThreeBData}
            singleHeader={singleHeader}
          />
        );
      default:
        return (
          <Gstr3bThreePointOneTableData
            tableHeaderData={tableHeaderData}
            gstrThreeBData={gstrThreeBData}
            singleHeader={singleHeader}
          />
        );
    }
  };
  return <>{renderTableData()}</>;
};

export default GstrThreeBTableData;
